<template>
  <el-form :inline="true" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">{{ title }} </span>
      </template>
    </el-page-header>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-descriptions title="供应商基本信息" :column="2">
        <el-descriptions-item label="供应商"
          ><span v-text="supplierInfo.name"></span
        ></el-descriptions-item>
        <!-- <el-descriptions-item label="结算方式">
          <el-tag round type="success" disable-transitions
            ><span v-text="util.showBalanceway(supplierInfo.balanceway)"></span>
          </el-tag>
        </el-descriptions-item> -->
        <el-descriptions-item label="付款方式">
          <el-tag round type="success" disable-transitions
            ><span v-text="util.showPayWay(supplierInfo.payway)"></span>
          </el-tag>
        </el-descriptions-item>
        <!-- <el-descriptions-item label="付款账户">
          <el-tag size="small"
            ><span v-text="supplierInfo.payaccount"></span
          ></el-tag>
        </el-descriptions-item> -->
        <el-descriptions-item label="有无合同"
          ><el-tag round type="warning" disable-transitions
            ><span
              v-text="util.showYesNo(supplierInfo.iscontract)"
            ></span> </el-tag
        ></el-descriptions-item>
        <el-descriptions-item label="账期"
          ><el-tag v-if="supplierInfo.isaccount" round type="danger" disable-transitions
            ><span
              v-text="util.supplierAccount(supplierInfo.isaccount)"
            ></span> </el-tag
        ></el-descriptions-item>
        <el-descriptions-item label="开票类型">{{
          util.showInvoiceType(supplierInfo.taxtype)
        }}</el-descriptions-item>
        <el-descriptions-item label="开票税点">{{
          supplierInfo.taxpoint
        }}</el-descriptions-item>
        <el-descriptions-item label="账期更新日期">{{supplierInfo.accounted}}</el-descriptions-item>
        <el-descriptions-item label="合同起止时间">{{supplierInfo.started}}至{{supplierInfo.ended}}</el-descriptions-item>
        <el-descriptions-item label="合同到期剩余天数">{{ supplierInfo.contractday }}</el-descriptions-item>
      </el-descriptions>
      <el-divider />

      <el-descriptions title="供应商商品类目信息" :column="2">
        <el-descriptions-item v-for="item in supplierCatalogs" :key="item">
          <el-tag round type="success" disable-transitions
            ><span v-text="item"></span
          ></el-tag>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider />

      <el-descriptions title="供应商商品品牌信息">
        <el-descriptions-item v-for="item in supplierBrand" :key="item">
          <el-tag round type="warning" disable-transitions
            ><span v-text="item"></span
          ></el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-col>
  </el-row>
</template>
<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { getSupplierInfo } from "@/api/supplier";
// import { listCatalog } from "@/api/catalog";
import util from "@/util/tool.js";

const router = useRouter();

const supplierid = ref(router.currentRoute.value.params.id);
const title = ref();

// const dictCatalogs = ref([]);
const supplierInfo = ref([]);
const supplierBrand = ref([]);
const supplierCatalog = ref([]);
const supplierCatalogs= ref([]);

//返回
const goback = () => {
  router.go(-1);
};

//onMounted方法
onMounted(() => {
  //getListCatalog();

  //详情
  getSupplierInfo({ supplierid: supplierid.value }).then((res) => {
    supplierInfo.value = JSON.parse(res.data.extend.suppliers.supplier[0])
    supplierBrand.value = res.data.extend.suppliers.brands
    supplierCatalog.value = res.data.extend.suppliers.catalogids
    supplierCatalogs.value =   res.data.extend.suppliers.catalogsTmp
    title.value = supplierInfo.value.name
  });
});

// const getListCatalog = () => {
//   listCatalog({ pageNo: 1, pageSize: 1000 }).then((res) => {
//     dictCatalogs.value = catalogReset(res.data.extend.pages.list);

//     let tmpCatalog = supplierCatalog.value;
//     let tmpData = []
//     tmpCatalog.forEach((item) => {
//         let tmp = findP(item, dictCatalogs.value)
//         tmpData.push(tmp.join(' > '))
//     });

//     supplierCatalogs.value = tmpData
//     console.log(tmpData);
//   });
// };

// const catalogReset = (catalogs) => {
//   let dataTmp = [];
//   catalogs.forEach((catalog) => {
//     // console.log(depart);
//     catalog.catalogid = catalog.catalogid.toString();
//     catalog.parentid = catalog.parentid.toString();
//     dataTmp.push(catalog);
//     catalogReset(catalog.children);
//   });
//   return dataTmp;
// };

// const findP = (id, list = [], result = []) => {
//   for (let i = 0; i < list.length; i += 1) {
//     // console.log("*******", list[i].catalogid, "********");
//     const item = list[i];
//     // 找到目标
//     if (item.catalogid === id) {
//     //   console.log("找到了");
//       // 加入到结果中
//       result.push(item.name);
//       // 因为可能在第一层就找到了结果，直接返回当前结果
//       if (result.length === 1) return result;
//       return true;
//     }
//     // 如果存在下级节点，则继续遍历
//     if (item.children) {
//       // 预设本次是需要的节点并加入到最终结果result中
//       result.push(item.name);
//       const find = findP(id, item.children, result);
//       // 如果不是false则表示找到了，直接return，结束递归
//       if (find) {
//         return result;
//       }
//       // 到这里，意味着本次并不是需要的节点，则在result中移除
//       result.pop();
//     }
//   }
//   // 如果都走到这儿了，也就是本轮遍历children没找到，将此次标记为false
//   return false;
// };
</script>